import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';

import Dialog from '/@/components/dialog';
import { _ } from '/@/locale';

@autobind
export default class ErrorDialog extends Component {
    static propTypes = {
        visible: PropTypes.bool,
        onClose: PropTypes.func.isRequired,
        onCancel: PropTypes.func,
        onAccept: PropTypes.func,
    };

    render() {
        const message = _(
            'El archivo seleccionado no pertenece al país activo. ¿Querés cambiar de país para continuar?'
        );
        return (
            <Dialog
                visible={this.props.visible}
                title={_('Cambiar de país')}
                message={message}
                acceptLabel={_('Cambiar de país')}
                onClose={this.props.onClose}
                onCancel={this.props.onCancel}
                onAccept={this.props.onAccept}
            />
        );
    }
}
